import classNames from 'classnames';
import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';
import contentItemCss from '#srcCssModules/advert/list-filter/advert-list-filter-content-item.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const Close: FC = () => {
  const { hideDetail } = useFilterContext();

  const handlerClick = () => {
    hideDetail();
  };

  return (
    <Button
      variant={ButtonVariant.unstyled}
      textUppercase
      additionalClassName={classNames(
        contentItemCss.advertListFilterContentItem,
        contentItemCss.advertListFilterContentItem_black,
      )}
      onClick={handlerClick}
    >
      <FormattedMessage defaultMessage="Close" />
    </Button>
  );
};

export { Close };
